<template>
  <!-- 顶部导航栏 -->
  <div class="top-nav">
    <div class="flex">
      <div class="left">
        <img class="logo" :src="logo" alt="" />
      </div>
      <div class="right">
        <div class="list">
          <router-link
            class="item"
            v-for="item in routerList"
            :key="item.id"
            :to="item.path"
            @mouseenter="navMove(item.id)"
            @mouseleave="navOut"
          >
            <div>{{ item.title }}</div>
            <img
              v-if="item.children"
              :src="selectMove == item.id ? item.open : item.close"
              alt=""
            />
            <div
              class="absolute"
              v-if="selectMove == item.id"
              :style="
                item.children
                  ? 'border: 1px solid rgba(36, 142, 251, 0.1);'
                  : ''
              "
              @mouseenter="navMove(item.id)"
              @mouseleave="navOut"
            >
              <router-link
                class="children"
                v-for="it in item.children"
                :key="it.id"
                :to="it.path"
                :class="it.path == '' ? 'active' : ''"
              >
                <div class="dian"></div>
                <div>{{ it.title }}</div>
              </router-link>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import logo from "../../../assets/home/logo.png";
import close from "../../../assets/home/close.png";
import open from "../../../assets/home/open.png";

export default {
  setup() {
    return reactive({
      logo: logo,
      routerList: [
        {
          id: 1,
          title: "首页",
          path: "/pc",
          children: "",
          open: open,
          close: close,
        },
        {
          id: 2,
          title: "关于畅月",
          path: "/pc/about",
          open: open,
          close: close,
          children: "",
        },
        {
          id: 3,
          title: "产品中心",
          path: "/pc/product",
          open: open,
          close: close,
          children: [
            {
              id: 1,
              title: "数字家园管理系统",
              path: "/pc/product/adminsystem",
            },
            {
              id: 2,
              title: "物联网平台",
              path: "/pc/product/things",
            },
            {
              id: 3,
              title: "物业APP、小程序",
              path: "/pc/product/property",
            },
            {
              id: 4,
              title: "居民APP、小程序",
              path: "/pc/product/resident",
            },
            {
              id: 5,
              title: "物业工单系统",
              path: "/pc/product/workorder",
            },
          ],
        },
        {
          id: 4,
          title: "解决方案",
          path: "/pc/programme",
          open: open,
          close: close,
          children: [
            {
              id: 1,
              title: "智能门禁",
              path: "/pc/programme/accesscontrol",
            },
            {
              id: 2,
              title: "智慧社区",
              path: "/pc/programme/community",
            },
            {
              id: 4,
              title: "智能监控",
              path: "/pc/programme/monitor",
            },
            {
              id: 5,
              title: "智慧物业",
              path: "/pc/programme/property",
            },
            {
              id: 7,
              title: "楼宇对讲",
              path: "/pc/programme/intercom",
            },
            {
              id: 11,
              title: "社区管理",
              path: "/pc/programme/communityadmin",
            },
            {
              id: 10,
              title: "智能梯控",
              path: "/pc/programme/laddercontrol",
            },
            {
              id: 3,
              title: "无人门岗",
              path: "/pc/programme/doorpost",
            },
            {
              id: 13,
              title: "智能家居",
              path: "/pc/programme/homefurnishing",
            },
            {
              id: 6,
              title: "智能安防",
              path: "/pc/programme/security",
            },
            {
              id: 14,
              title: "智能充电",
              path: "/pc/programme/charge",
            },
            {
              id: 12,
              title: "财务管理",
              // path: "/pc/programme/financeadmin",
              path: "",
            },
            {
              id: 15,
              title: "智能停车",
              path: "/pc/programme/parking",
            },
            {
              id: 9,
              title: "智能消防",
              // path: "/pc/programme/firecontrol",
              path: "",
            },
            {
              id: 16,
              title: "智能能耗",
              // path: "/pc/programme/energyconsumption",
              path: "",
            },
            {
              id: 17,
              title: "智慧商圈",
              // path: "/pc/programme/businessdistrict",
              path: "",
            },
            {
              id: 18,
              title: "智慧防疫",
              path: "/pc/programme/epidemicprevention",
            },
          ],
        },
        {
          id: 5,
          title: "资讯动态",
          path: "/pc/dynamic",
          open: open,
          close: close,
          children: "",
        },
        {
          id: 6,
          title: "党建引领",
          path: "/pc/party",
          open: open,
          close: close,
          children: "",
        },
        {
          id: 7,
          title: "联系我们",
          path: "/pc/contact",
          open: open,
          close: close,
          children: "",
        },
      ],
      selectMove: 0,
    });
  },
  methods: {
    navMove(id) {
      this.selectMove = id;
    },
    navOut() {
      this.selectMove = 0;
    },
  },
};
</script>

<style scoped>
.flex {
  width: 1180px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex .left .logo {
  width: 202px;
  padding: 5px 0;
}
.flex .right .list {
  display: flex;
}
.flex .right .list .item {
  display: flex;
  align-items: center;
  position: relative;
}
.flex .right .list .item img {
  width: 12px;
  margin-left: 8px;
}
a {
  padding: 16px;
  font-size: 16px;
  color: #333;
  text-decoration: none;
}
.router-link-active {
  color: #248efb;
}
.item:hover {
  color: #248efb;
}
.absolute {
  width: 290px;
  position: absolute;
  top: 53px;
  z-index: 999;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  border-radius: 0 0 10px 10px;
}
.children {
  display: flex;
  align-items: center;
  padding: 20px 30px;
}
.children:hover {
  color: #248efb;
}
.dian {
  width: 4px;
  height: 4px;
  background: #248efb;
  margin-right: 15px;
}
.absolute .active {
  color: #333;
}
.absolute .active:hover {
  color: #248efb;
}
</style>
